
const QUERY_PARAMS = Object.freeze({
  PAGE: 'page',
  CATEGORY: 'category',
  NAME: 'name',
  ID: 'id',
  SEARCH_TERM: 'searchTerm',
  LIST_ID: 'listId'
});

export default QUERY_PARAMS;
